export default {
  updatePage: {
    majorUpdateTitle: 'Major Update!',
    majorUpdateMessage: 'To access Tokatab, please download the new version from the stores.',
    regularUpdateTitle: 'Application Update',
    regularUpdateMessage: 'Tokatab will be available in a few seconds!',
  },
  storeMobilePage: {
    accountCreatedTitle: 'Your account has been created! Please install the app to use Tokatab.',
    subscriptionPrompt: 'Want to subscribe to Tokatab? You\'re in the right place!',
    subscribe: 'Subscribe',
    downloadAppTitle: 'Download the app to use Tokatab!',
    clickLogoIfInstalled: 'If you already have the app, click on the logo',
    clickButtonToInstall: 'Click the button below to install it',
    logout: 'Logout',
  },
  offlinePage: {
    internetRequired: 'You must be connected to the Internet to use Tokatab.',
    checkConnection: 'Please check your connection before trying again.',
    retry: 'Retry'
  },
  maintenancePage: {
    title: 'Maintenance in progress',
    message: 'We\'re working as fast as possible to restore access to Tokatab!',
    retry: 'Retry'
  },
  errorUpdatePage: {
    title: 'An error occurred during the update...',
    contactSupport: 'Contact Support',
    retry: 'Retry'
  },
  verifyEmailClient: {
    addressCopied: 'Address copied!',
    copyError: 'Error copying address!',
    contactVia: 'You can contact us via {email}.',
    copy: 'Copy'
  },
  promotionPopup: {
    onSubscriptions: 'On our <span class="text-yellow-6">annual</span> and <span class="text-yellow-6">lifetime</span> subscriptions',
    codeLabel: 'Promo code:',
    validUntil: 'Offer valid until {endDate} inclusive!',
    subscribeButton: 'I\'m subscribing',
    annualSubscription: 'Annual Subscription',
    monthlySubscription: 'Monthly Subscription',
    lifetimeSubscription: 'Lifetime Subscription',
    perMonth: '(or {price}/month)'
  },
  promotionChip: {
    promotionInProgress: 'Promotion in progress! Get <strong>-{value}%</strong> off until {endDate}',
    withCode: 'using code:',
    allSubscriptions: 'on all our subscriptions',
    annualAndLifetime: 'on our annual and lifetime subscriptions',
    benefitReduction: 'Get -{value}% off {subscriptionType} by writing to us at contact@tokatab.com'
  },
  mobileNavBar: {
    home: 'Home',
    skills: 'Skills',
    lessons: 'Lessons',
    pieces: 'Songs',
    challenges: 'Challenges'
  },
  desktopHeader: {
    midiTooltip: 'Use your MIDI keyboard for a better experience!',
    midiLabel: 'MIDI Keyboard',
    midiConnected: '{deviceName}: connected!',
    home: 'Home',
    pieces: 'Songs',
    challenges: 'Challenges',
    skills: 'Skills',
    lessons: 'Lessons',
    progress: 'Progress'
  },
  notificationPermissionDeniedModal: {
    title: 'Notification activation',
    firstTimeDisabled: 'The first time, you disabled notifications, but you can reactivate them at any time by going to settings via the button below.',
    canLeaveDisabled: 'You can also choose to leave them disabled, but in this case, you will not receive any notifications.',
    dontActivate: 'Don\'t activate them',
    activateNotifications: 'Activate notifications'
  },
  freemiumSubscriptionPopup: {
    quotaReached: 'Import quota reached',
    freeContentExhausted: 'Free content exhausted',
    importUnlimited: 'Import your own songs unlimited with a Premium subscription.',
    unlockToday: 'Unlock unlimited learning today for less than $5 per month.',
    perMonth: '/ month',
    customPath: 'Custom path',
    thousandContent: '1000+ content',
    unlimitedImport: 'Unlimited sheet music import',
    unlimitedAll: 'Unlimited access to all Tokatab content (1000+ exercises, 100+ pieces)',
    dailyRenewal: 'Your 3 free daily content renews every day at 00:00',
    weeklyRenewal: 'Your 5 free weekly content renews every Monday at 00:00',
    nextRenewal: 'Next renewal: {date}',
    subscribeNow: 'Subscribe now',
    seeAllBenefits: 'See all benefits',
    limitedOffer: '🎹 LIMITED OFFER -{promotion}%',
    importPiecesUnlimited: 'Import your songs',
    inUnlimited: 'unlimited',
    rightNow: 'right now',
    continuePlayingLearning: 'Continue playing and',
    learn: 'learning',
    noLimitImport: 'No more limit on importing your personal MusicXML songs',
    unlimitedAccess: 'Unlimited access to all exercises, songs, challenges and a custom path',
    savePercent: 'SAVE {promotion}%',
    everythingNeeded: 'Everything you need to',
    masterPiano: 'master the piano',
    satisfied: 'More than 5,000 satisfied learners',
    dailyContentRenewal: '📆 Your 3 free daily content renews every day at 00:00',
    weeklyContentRenewal: '📆 Your 5 free weekly content renews every Monday at 00:00',
    seeOtherSubscriptions: 'See other subscriptions',
    cancelAnytime: 'Cancel anytime • No commitment',
    benefits: {
      unlimitedAccessTitle: 'Unlimited access',
      unlimitedAccess: 'Unlimited access to all content',
      virtualTeacherTitle: 'Virtual teacher',
      virtualTeacher: 'Personalized virtual teacher',
      progressTrackingTitle: 'Progress tracking',
      progressTracking: 'Detailed progress tracking',
      importPiecesTitle: 'Sheet music import',
      importPieces: 'Import your own songs unlimited'
    },
    testimonials: {
      1: {
        text: 'Self-taught for a year with the internet, I mainly played songs with just one hand.. so I\'m happy because the exercises allow me to practice playing both hands at the same time which I couldn\'t do alone',
        author: 'Pierre Dardenne, by email to the Tokatab team'
      },
      2: {
        text: 'I really like it, especially when the app plays the sound of the other hand that I\'m not playing. It\'s cooler for training and pleasant to hear',
        author: 'Posipi 83, on the Play store'
      },
      3: {
        text: 'Your method is effective, my right-hand chord playing is much better than before. I play with ease songs that I thought were too difficult for me just a few months ago, like georgia on my mind. My 13-year-old son also made an account and made nice progress. Thanks to the whole team for this good learning tool!',
        author: 'Marco78, by email to the Tokatab team'
      },
      4: {
        text: 'Top app! Having tested several competing apps, Tokatab is by far the best in terms of technical piano learning',
        author: 'Cassandre349, on App store'
      },
      5: {
        text: 'After 2 years with Tokatab I took the leap and got a teacher, I needed to take this step. He found that my hands already had good reflexes and thought I had taken lessons before. Anyway, thank you for the application and even though I take lessons on the side, I continue my routine of 2 to 3 sessions per week with tokatab 😉',
        author: 'Myriam, by email to the Tokatab team'
      },
      6: {
        text: 'I had been planning to learn piano for several years. Finally, at 40, I discovered almost by chance the Tokatab app, created by a piano teacher to learn piano. The subscription price is really not expensive to have a quasi piano teacher at home available 24/7. The lessons are progressive and allowed me to advance super fast in 2-3 months, I mean I can play with 2 hands! Plus you can learn songs! Top!',
        author: 'Sarah, by email to the Tokatab team'
      },
      7: {
        text: 'Perfect for getting back to piano at my own pace. After taking piano lessons in my youth, Tokatab allowed me to get back to it without having to pay for in-person lessons. The lessons are accessible and adapted to my busy schedule. A practical and economical solution, I love it 🙂',
        author: 'Fanny Therry, on the Play store'
      },
      8: {
        text: 'Unlike other applications, the real "plus" of Tokatab is that the app is designed to master your piano (with exercises, mastery of certain gestures and positions…), and not just to play a song. Top!',
        author: 'HolivYeahhh, on App store'
      },
      9: {
        text: 'Very good app, the exercises are great!',
        author: 'Qiao Qiao, on the Play store'
      }
    }
  }
};